import { ref } from 'vue'
// import { _debounce } from '@shared/libs/lodash'

export function usePagination() {
  const initialRequestComplete = ref(false)
  const totalItemsOnPage = ref(0)
  const tooManyRowsDialogOptions = ref({
    maxRows: 10000,
    visible: false,
    header: 'Attention',
    body: '<p>The system can currently only fetch 10,000 records at a time, so some results are missing.</p><p>You can use the column filters or Quick Filter to refine your results.</p>',
    buttonLabel: 'I understand',
    noBackdrop: true,
  })

  const updateTooManyRowsDialogVisibility = (value) => tooManyRowsDialogOptions.value.visible = value

  const onPaginationChanged = (event, gridApi, gridState) => {
    if (!gridApi.value || !initialRequestComplete.value) return

    const pageSize = gridApi.value.paginationGetPageSize()
    const currentPage = gridApi.value.paginationGetCurrentPage()
    const totalPages = gridApi.value.paginationGetTotalPages()
    const countRowsFetched = pageSize * (currentPage + 1)
    const rowCount = gridApi.value.paginationGetRowCount()

    if (totalPages > 1) {
      const gridContext = event.api.getGridOption('context')
      if (gridContext?.esPaginationApiType === 'search_after') {
        if (totalPages === currentPage + 1 && !gridContext.reverseSearch) {
          delete gridContext.searchAfter
          gridApi.value.setGridOption('context', {
            ...gridContext,
            reverseSearch: true,
            })
        }
        if (currentPage === 0 && gridContext.reverseSearch) {
          delete gridContext.searchAfter
          gridApi.value.setGridOption('context', {
            ...gridContext,
            reverseSearch: false,
          })
        }
      }
    }

    if (countRowsFetched > rowCount) totalItemsOnPage.value = rowCount - pageSize * currentPage
    else totalItemsOnPage.value = pageSize

    gridState.saveCurrentPageState(currentPage)
  }

  const markInitialRequestComplete = (gridApi, gridState) => {
    initialRequestComplete.value = true

    const storedPageState = gridState.loadCurrentPageState()

    if (storedPageState) gridApi.value.paginationGoToPage(Number(storedPageState))
  }

  return {
    initialRequestComplete,
    totalItemsOnPage,
    tooManyRowsDialogOptions,
    updateTooManyRowsDialogVisibility,
    onPaginationChanged,
    markInitialRequestComplete,
  }
}
